import './style.scss';
import 'swiper/swiper.scss';
import Swiper from "swiper";
import { Navigation, Autoplay } from 'swiper/modules';

export function event_highlights_block() {

    const blocks = document.querySelectorAll('.event_highlights_block');
    if (!blocks.length) return;

    blocks.forEach((block) => {

        const swiperContainer = block.querySelector('.event-highlights-swiper');
        if (!swiperContainer) return;

        const nextBtn = block.querySelector('.swiper-button-next');
        const prevBtn = block.querySelector('.swiper-button-prev');

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            speed: 1000,
            loop: true,
            modules: [Navigation, Autoplay],
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            on: {
                slideChangeTransitionEnd: function () {
                    if (prevBtn && prevBtn.classList.contains('is-beginning')) {
                        prevBtn.classList.remove('is-beginning');
                    }
                },
            },
        });



        swiper.on('touchEnd', () => {
            swiper.autoplay.stop();
            setTimeout(() => {
                swiper.autoplay.start();
            }, 5000); 
        });

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                swiper.autoplay.stop();
                setTimeout(() => {
                    swiper.autoplay.start();
                }, 5000);
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                swiper.autoplay.stop();
                setTimeout(() => {
                    swiper.autoplay.start();
                }, 5000);
            });
        }
    });
}
